import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calcule',
  templateUrl: './calcule.component.html',
  styleUrls: ['./calcule.component.scss']
})
export class CalculeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
